module.exports = __webpack_public_path__ + "img/facebook.d09f6f4a.svg";